import { createStyles } from "@mantine/styles";

export const useStyles = createStyles((theme, params, getRef) => ({
  paginationWrapper: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
  },
}));
